import { LandingPage } from '@/components/landing/LandingPage.tsx';

const Index = () => {
  return <LandingPage />;
};

export default Index;